import React from "react";
import { ToastContainer } from "react-toastify";

import GiftCardProductsList from "./components/GiftCardProductsList";

const GiftCardProductsApp = (props) => (
  <>
    <ToastContainer icon={false} />
    <GiftCardProductsList {...props} />
  </>
);

export default GiftCardProductsApp;
